import React from "react"
import { css } from "@emotion/core"
import Divider from "components/UI/Divider"
import t, { mixin } from "theme"

const ColumnTitle = ({ children }) => (
    <div
        css={css`
            margin-bottom: ${t.space[7]};
            ${mixin.tabletandphonestyle} {
                margin-bottom: ${t.space[5]};
            }
        `}>
        <div
            css={css`
                color: ${t.color.darktext};
                font-weight: ${t.font.weight.semibold};
                font-size: ${t.font.size[6]};
                letter-spacing: ${t.font.spacing[7]};
                text-transform: uppercase;
            `}>
            {children}
        </div>
        <Divider color={t.color.primary} width="2px" size="3.5rem" />
    </div>
)

export default ColumnTitle
